const axios = require('axios');
const { API_HOST } = require('../config/app-const');

function apiUrl(path) {
    if (path.startsWith('http')) {
        return path;
    }
    return `${API_HOST}/${path.replace(/^\//, '')}`;
}

const download_file = (url, file = {}, token) => {
    const config = {
        responseType: 'blob',
        withCredentials: true,
    };
    if (token) {
        config.headers = { Authorization: `Token token=${token}` };
    }

    axios.post(apiUrl(url), file, config).then((response) => {
        const download_url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = download_url;
        link.setAttribute('download', file.file);
        document.body.appendChild(link);
        link.click();
    });
};

const download_blob = (url, data = {}, token, fileName = null) => {
    const config = {
        responseType: 'blob',
        withCredentials: true,
    };
    if (token) {
        config.headers = { Authorization: `Token token=${token}` };
    }

    return axios.post(apiUrl(url), data, config)
        .then((response) => {
            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = `${fileName.trim()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);

            return response;
        });
};

export { download_file, download_blob };
